__webpack_require__.p = "/Proyecto-Simpsons/";